import React, { Children, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { v4 } from 'uuid';
import FormRadio from './FormRadio';
import './FormIconChooser.css';

const IconChooser = props => {
  const { className, children, itemClass } = props;

  // memoizing children prevents flicker from re-renders
  const renderIcons = useMemo(
    () =>
      Children.toArray(children).map(Child => (
        <li
          key={v4()}
          className={classnames('icon-chooser-list__item', itemClass)}
        >
          {Child}
        </li>
      )),
    [children, itemClass]
  );

  return (
    <ul className={classnames('icon-chooser', className)}>{renderIcons}</ul>
  );
};

IconChooser.defaultProps = {
  children: [],
  itemClass: undefined,
  className: undefined
};

IconChooser.propTypes = {
  children: (props, propName, componentName) => {
    const prop = props[propName];

    let error = null;
    React.Children.forEach(prop, child => {
      if (child.type !== FormRadio) {
        error = new Error(
          `"${componentName}" children should be of type "FormRadio".`
        );
      }
    });
    return error;
  },
  itemClass: PropTypes.string,
  className: PropTypes.string
};

export default IconChooser;



// WEBPACK FOOTER //
// ./src/components/form/FormIconChooser.js